export function scrollSurgeonWorkspaceToTop(target: HTMLElement | null) {
  if (!target) return;

  const behavior = 'instant' as ScrollBehavior;
  const main = document.querySelector('main');

  if (main instanceof HTMLElement && typeof main.scrollTo === 'function') {
    const mainRect = main.getBoundingClientRect();
    const targetRect = target.getBoundingClientRect();
    const top = Math.max(0, main.scrollTop + targetRect.top - mainRect.top);

    main.scrollTo({ top, behavior });
    return;
  }

  target.scrollIntoView({ behavior, block: 'start' });
}

export function scheduleSurgeonWorkspaceScrollToTop(getTarget: () => HTMLElement | null) {
  const run = () => scrollSurgeonWorkspaceToTop(getTarget());

  if (typeof window !== 'undefined' && typeof window.requestAnimationFrame === 'function') {
    window.requestAnimationFrame(run);
    return;
  }

  setTimeout(run, 0);
}
